/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPencilDown = createReactComponent("pencil-down", "IconPencilDown", [
  [
    "path",
    {
      d: "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4",
      key: "svg-0"
    }
  ],
  ["path", { d: "M13.5 6.5l4 4", key: "svg-1" }],
  ["path", { d: "M19 16v6", key: "svg-2" }],
  ["path", { d: "M22 19l-3 3l-3 -3", key: "svg-3" }]
]);

export { IconPencilDown as default };
//# sourceMappingURL=IconPencilDown.js.map
